import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap'
import { Link } from "@StarberryUtils"
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const FloorPlanModal = (props) => {
    const [show, setShow] = useState(false);


    var lightImages2 = []

    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const openLighboxMobile = (e, ind) => {
        e.preventDefault();
        setPhotoIndex(ind);
        setIsOpen(true);
    }

    lightImages2.push(props.floorplanimg)

    return (
        <>
            <a href="javascript:void(0)" className="map-expand-link" onClick={(e) => openLighboxMobile(e,0)}><i className="icon-floor"></i></a>

            {isOpen && lightImages2.length != 0 && (
                <Lightbox
                    wrapperClassName="light-box-image-zoom"
                    mainSrc={lightImages2[photoIndex]}
                    // nextSrc={lightImages2[(photoIndex + 1) % lightImages2.length]}
                    // prevSrc={lightImages2[(photoIndex + lightImages2.length - 1) % lightImages2.length]}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() =>
                    setPhotoIndex((photoIndex + lightImages2.length - 1) % lightImages2.length)
                    }
                    onMoveNextRequest={() =>
                    setPhotoIndex((photoIndex + 1) % lightImages2.length)
                    }
                />
            )}
        </>
    );
}

export default FloorPlanModal;
